import { User } from "../../../bos_common/src/types/UserTypes";
import { RootState } from "../../store"

export const getToken = (state: RootState): string => state.auth.entities.token;

export const getUser = (state: RootState): User | null => state.auth.entities.user;
